<div class="term">
  <body>
    <h1 style="padding-top: 4pt; text-indent: 0pt; text-align: center">
      <a name="bookmark0">&zwnj;</a>TERMOS DE USO DA PLATAFORMA Church Web
    </h1>
    <p><br /></p>
    <p><a name="bookmark1">&zwnj;</a><span class="h1">Termos de uso da </span><span>church web </span></p>
    <p><br /></p>
    <ol id="l1">
      <li data-list-text="1.">
        <h1><a name="bookmark2">&zwnj;</a>Informações gerais.</h1>

        <ol id="l2">
          <li data-list-text="1.1.">
            <p style="padding-left: 5pt; text-indent: 3pt; line-height: 108%; text-align: justify">
              <a name="bookmark3">&zwnj;</a><span class="p">Os presentes </span><span class="h1">Termos de Uso </span
              ><span class="p">regulam os serviços oferecidos pela plataforma </span><span>church web </span
              ><span class="p"
                >, que consistem na disponibilização de um ambiente virtual para congregação de pessoas pertencentes a
                um mesmo grupo religioso, podendo, na plataforma, interagir entre si e manter listas de frequência e de
                controle de assiduidade, quadro de avisos e materiais compartilhados de leitura.</span
              >
            </p>
          </li>
          <li data-list-text="1.2.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark4">&zwnj;</a><span class="p">A plataforma </span><span>church web </span
              ><span class="h1"> </span><span class="p">é um produto da SiprySoft, CNPJ de nº </span
              ><span class="s2">54.009.902/0001-18</span
              ><span class="p">, que detém todos os direitos de propriedade intelectual sobre o software.</span>
            </p>
          </li>
          <li data-list-text="1.3.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark5">&zwnj;</a
              ><span class="p"
                >A SiprySoft se reserva o direito de fazer modificações, aprimoramentos e atualizações nas
                funcionalidades da plataforma </span
              ><span>church web </span><span class="p">, incluindo mudanças e melhorias de </span
              ><span class="s3">layout</span
              ><span class="p"
                >, sempre atuando no interesse de oferecer um melhor serviço e se comprometendo a preservar ao máximo
                suas funcionalidades necessárias e não causar quaisquer prejuízos aos seus usuários.</span
              >
            </p>
          </li>
          <li data-list-text="1.4.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark6">&zwnj;</a
              ><span class="p"
                >A SiprySoft emprega seus esforços para a disponibilidade contínua e permanente da plataforma </span
              ><span>church web </span
              ><span class="p"
                >; poderá ocorrer, excepcionalmente, alguma indisponibilidade temporária decorrente de manutenção
                necessária ou motivada por força maior, como desastres da natureza, falhas ou colapsos nos sistemas
                centrais de comunicação e acesso à internet, ou fatos de terceiro que fogem à sua
                responsabilidade.</span
              >
            </p>

            <ol id="l3">
              <li data-list-text="1.4.1.">
                <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
                  <a name="bookmark7">&zwnj;</a
                  ><span class="p"
                    >Em havendo indisponibilidade do serviço, a SiprySoft se compromete em atuar em todas as medidas que
                    estiverem dentro de seu alcance, dentro das limitações técnicas de seus serviços próprios ou de
                    terceiros, para a finalidade de restabelecer o acesso à plataforma </span
                  ><span>church web </span><span class="h1"> </span><span class="p">o mais breve possível.</span>
                </p>
              </li>
              <li data-list-text="1.4.2.">
                <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
                  <a name="bookmark8">&zwnj;</a><span class="p">O usuário da </span><span>church web </span
                  ><span class="h1"> </span
                  ><span class="p"
                    >isenta a empresa SiprySoft de qualquer dano ocorrido em virtude de paralisação de seus serviços,
                    parciais ou totais, decorrentes de falta temporária de energia elétrica, de pane nos serviços das
                    concessionárias, de falhas nos serviços oferecidos pelas redes telefônicas e provedores de internet,
                    incluindo provedores de hospedagem, além de greves, tumultos, revoltas ou quaisquer outros fatos,
                    naturais ou humanos, que não tenham correlação com os serviços prestados via plataforma </span
                  ><span>church web </span
                  ><span class="p"
                    >. A SiprySoft também não se responsabiliza por qualquer dano causado em razão de caso fortuito ou
                    força maior, bem como culpa exclusiva da vítima, fato de terceiro ou quaisquer outras causas de
                    excludente de responsabilidade civil.</span
                  >
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="1.5.">
            <p style="padding-top: 4pt; padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark9">&zwnj;</a
              ><span class="p">Eventuais procedimentos de manutenção necessários da plataforma </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p"
                >serão informados, sempre que possível, com a devida antecedência e, através dos canais oficiais de
                comunicação da </span
              ><span>church web </span
              ><span class="p">, como por exemplo, suporte virtual e outras comunicações eletrônicas.</span>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="2.">
        <h1 style="padding-left: 17pt; text-indent: -12pt; text-align: justify">
          <a name="bookmark10">&zwnj;</a>Do objeto.
        </h1>

        <ol id="l4">
          <li data-list-text="2.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark11">&zwnj;</a><span class="p">O objeto do presente contrato de </span
              ><span class="h1">Termos de Uso </span
              ><span class="p">é o fornecimento das funcionalidades da plataforma </span><span>church web </span
              ><span class="p">, conforme descritas no item </span><span class="h1">1.1.</span>
            </p>
          </li>
          <li data-list-text="2.2.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark12">&zwnj;</a>A SiprySoft se resguarda no direito de tomar as medidas cabíveis, civil e
              penalmente, contra os Usuários que usarem de sua plataforma para finalidades ilícitas e diversas daquelas
              tratadas nestes <b>Termos de Uso</b>.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="3.">
        <h1 style="padding-left: 18pt; text-indent: -13pt; text-align: justify">
          <a name="bookmark13">&zwnj;</a>Do usuário.
        </h1>
        <ol id="l5">
          <li data-list-text="3.1.">
            <p style="padding-top: 8pt; padding-left: 5pt; text-indent: 0pt; text-align: justify">
              <a name="bookmark14">&zwnj;</a
              ><span class="p"
                >Qualquer pessoa física que goze de capacidade civil pode ser Usuário da plataforma da </span
              ><span>church web </span
              ><span class="p">, desde que se conforme aos fins da plataforma e obedeça aos ditames destes </span
              ><span class="h1">Termos de Uso</span><span class="p">.</span>
            </p>
          </li>
          <li data-list-text="3.2.">
            <p style="padding-top: 8pt; padding-left: 5pt; text-indent: 0pt; text-align: justify">
              <a name="bookmark15">&zwnj;</a>O Usuário declara, através da concordância com estes <b>Termos de Uso</b>,
              ser civilmente capaz e ter plenos poderes para aceitar este contrato.
            </p>
          </li>
          <li data-list-text="3.3.">
            <p style="padding-top: 8pt; padding-left: 5pt; text-indent: 0pt; text-align: justify">
              <a name="bookmark16">&zwnj;</a><span class="p">O Usuário da </span><span>church web </span
              ><span class="h1"> </span
              ><span class="p">se comprometem a fornecer dados exatos e verdadeiros, devendo ler e aceitar a </span
              ><span class="h1">Política de Privacidade </span
              ><span class="p">da plataforma antes de seu primeiro acesso, de forma que a </span><span>church web </span
              ><span class="h1"> </span
              ><span class="p"
                >não se responsabiliza por eventual inexatidão ou inautenticidade de dados fornecidos nas telas de
                cadastro do Usuário.</span
              >
            </p>
          </li>
          <li data-list-text="3.4.">
            <p style="padding-top: 8pt; padding-left: 5pt; text-indent: 0pt; text-align: justify">
              <a name="bookmark17">&zwnj;</a
              ><span class="p">Caso a SiprySoft verifique a existência de alguma atividade suspeita na plataforma </span
              ><span>church web </span
              ><span class="p"
                >, poderá, a qualquer tempo e a seu exclusivo critério, requisitar a confirmação de identidade do
                Usuário, podendo, assim, solicitar documentos de identificação ou outras formas de comprovação de
                identidade.</span
              >
            </p>
            <ol id="l6">
              <li data-list-text="3.4.1.">
                <p style="padding-top: 8pt; padding-left: 5pt; text-indent: 0pt; text-align: justify">
                  <a name="bookmark18">&zwnj;</a>Qualquer erro ou atraso no processo de envio ou confirmação da
                  identidade pelo próprio Usuário será considerado de inteira responsabilidade dele mesmo.
                </p>
              </li>
            </ol>
          </li>
          <li data-list-text="3.5.">
            <p style="padding-top: 8pt; padding-left: 5pt; text-indent: 0pt; text-align: justify">
              <a name="bookmark19">&zwnj;</a
              ><span class="p"
                >A SiprySoft se reserva, nos termos deste contrato, a proceder com a advertência, suspensão ou
                cancelamento da conta perfil do Usuário na plataforma </span
              ><span>church web </span><span class="p">, caso o Usuário:</span>
            </p>
            <ol id="l7">
              <li data-list-text="I">
                <p style="padding-top: 8pt; padding-left: 5pt; text-indent: 0pt; text-align: left">
                  <a name="bookmark20">&zwnj;</a
                  ><span class="p"
                    >- Descumpra com qualquer disposição destes Termos ou qualquer outra política da </span
                  ><span>church web </span><span class="p">;</span>
                </p>
              </li>
              <li data-list-text="II">
                <p>
                  <a name="bookmark21">&zwnj;</a><span class="p">- Utilize da plataforma </span><span>church web </span
                  ><span class="h1"> </span><span class="p">para praticar atos fraudulentos ou ilícitos em geral;</span>
                </p>
              </li>
              <li data-list-text="III">
                <p>
                  <a name="bookmark22">&zwnj;</a><span class="p">- na utilização da plataforma </span
                  ><span>church web </span
                  ><span class="p">, dê causa a qualquer tipo de dano ou prejuízo a terceiro ou à SiprySoft.</span>
                </p>
              </li>
            </ol>
          </li>
        </ol>
      </li>
      <li data-list-text="4.">
        <p style="padding-top: 13pt; padding-left: 17pt; text-indent: -12pt; text-align: left">
          <a name="bookmark23">&zwnj;</a><span class="h1">Do acesso à plataforma </span><span>church web </span>
        </p>
        <ol id="l8">
          <li data-list-text="4.1.">
            <p style="padding-top: 4pt; padding-left: 5pt; text-indent: 0pt; text-align: left">
              <a name="bookmark24">&zwnj;</a><span class="p">O acesso de usuários aos serviços da plataforma </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p">depende de cadastro, com a criação de conta.</span>
            </p>
            <p style="padding-top: 10pt; text-indent: 0pt; text-align: left"><br /></p>
          </li>
          <li data-list-text="4.2.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark25">&zwnj;</a
              ><span class="p">A criação de uma conta perfil de Usuário na plataforma </span><span>church web </span
              ><span class="p"
                >pode ser gerada fornecendo-se dados pessoais de cadastro, como o nome completo, gênero, e-mail,
                telefone, endereço, login e senha.</span
              >
            </p>
          </li>
          <li data-list-text="4.3.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark26">&zwnj;</a><span class="p">Os dados de login e senha de acesso à plataforma </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p"
                >são personalíssimos e intransferíveis, e o Usuário se compromete a não informar estes dados a
                terceiros, responsabilizando-se integralmente perante à SiprySoft pelo uso que terceiros façam de tais
                dados.</span
              >
            </p>
            <p><br /></p>
          </li>
          <li data-list-text="4.4.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark27">&zwnj;</a><span class="p">Em caso de suspeita de que seus dados de </span
              ><span class="s3">login </span
              ><span class="p">e senha tenham parado nas mãos de terceiros, os administradores da </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p"
                >devem ser notificados imediatamente para que sejam realizados os procedimentos de recuperação da senha
                e do </span
              ><span class="s3">login</span
              ><span class="p"
                >. A SiprySoft não se responsabiliza por quaisquer perdas e danos resultantes do acesso não autorizado
                ou do uso da conta por terceiro.</span
              >
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="5.">
        <h1 style="padding-left: 21pt; text-indent: -16pt; text-align: left">
          <a name="bookmark28">&zwnj;</a>Do Usuário dos serviços.
        </h1>
        <ol id="l9">
          <li data-list-text="5.1.">
            <p style="padding-top: 10pt; padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark29">&zwnj;</a
              ><span class="p"
                >Quando o Usuário requisitar auxílio do suporte da SiprySoft ou de algum dos canais de atendimento da
                plataforma </span
              ><span>church web </span
              ><span class="p"
                >, alguns de seus dados pessoais podem ser requisitados para fins de conferência da sua identidade ou
                para a solução do problema.</span
              >
            </p>
          </li>
          <li data-list-text="5.2.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark30">&zwnj;</a
              ><span class="p"
                >O Usuário assume total responsabilidade sobre a veracidade das informações prestadas, assim como se
                compromete a atualizá-las sempre que for necessário. Além de prestar seu aceite aos presentes </span
              ><span class="h1">Termos de Uso </span><span class="p">e a </span
              ><span class="h1">Política de Privacidade </span><span class="p">da plataforma </span
              ><span>church web </span
              ><span class="p">, pelos quais declara seu consentimento para o tratamento de seus dados pessoais.</span>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="6.">
        <h1 style="padding-left: 18pt; text-indent: -13pt; text-align: left">
          <a name="bookmark31">&zwnj;</a>Das obrigações relativas à plataforma church web .
        </h1>

        <ol id="l10">
          <li data-list-text="6.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark32">&zwnj;</a
              ><span class="p"
                >A SiprySoft se compromete a zelar pela proteção e privacidade de dados pessoais coletados na plataforma </span
              ><span>church web </span
              ><span class="p">, dentro dos parâmetros dispostos em lei e em seu documento de </span
              ><span class="h1">Política de Privacidade</span><span class="p">.</span>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="7.">
        <h1 style="padding-left: 18pt; text-indent: -13pt; text-align: left">
          <a name="bookmark33">&zwnj;</a>Da política de privacidade.
        </h1>

        <ol id="l11">
          <li data-list-text="7.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark34">&zwnj;</a><span class="p">A SiprySoft se compromete, através destes </span
              ><span class="h1">Termos de Uso</span
              ><span class="p"
                >, a respeitar e zelar pela privacidade e proteção de dados pessoais dos Usuários da plataforma </span
              ><span>church web </span><span class="p">.</span>
            </p>
          </li>
          <li data-list-text="7.2.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: left">
              <a name="bookmark35">&zwnj;</a
              ><span class="p">As diretrizes e as respectivas responsabilidades estão previstas no documento de </span
              ><span class="h1">Política de Privacidade</span><span class="p">, disponível na plataforma </span
              ><span>church web </span><span class="p">.</span>
            </p>
          </li>
          <li data-list-text="7.3.">
            <p style="padding-top: 4pt; padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark36">&zwnj;</a>Em todo caso em que haja conflito entre o disposto nestes
              <b>Termos de Uso </b>e no documento de <b>Política de Privacidade</b>, deverá prevalecer o escrito na
              norma mais específica.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="8.">
        <h1 style="padding-left: 18pt; text-indent: -13pt; text-align: justify">
          <a name="bookmark37">&zwnj;</a>Da vigência do presente contrato de Termos de Uso.
        </h1>

        <ol id="l12">
          <li data-list-text="8.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark38">&zwnj;</a>O presente instrumento tem vigência a partir do aceite do Usuário aos
              <b>Termos de Uso</b>, com o preenchimento de seus dados pessoais e a declaração de seu consentimento.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="9.">
        <h1 style="padding-left: 18pt; text-indent: -13pt; text-align: justify">
          <a name="bookmark39">&zwnj;</a>Dos direitos de propriedade intelectual.
        </h1>

        <ol id="l13">
          <li data-list-text="9.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark40">&zwnj;</a><span class="p">O conteúdo da plataforma da </span><span>church web </span
              ><span class="h1"> </span
              ><span class="p"
                >está sujeito a direitos autorais, proteção de software e outros direitos de propriedade intelectual no
                âmbito das convenções legais internacionais e locais. O uso indevido e a reprodução total ou parcial dos
                referidos conteúdos ou nomes são proibidos, salvo mediante autorização expressa da SiprySoft.</span
              >
            </p>
            <p><br /></p>
          </li>
          <li data-list-text="9.2.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark41">&zwnj;</a><span class="p">A SiprySoft declara usar em sua plataforma </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p"
                >apenas conteúdo que é permitido e autorizado para utilização pelo(s) proprietário(s) dos direitos
                autorais e de outros direitos de propriedade intelectual aqui estabelecidos.</span
              >
            </p>
          </li>
          <li data-list-text="9.3.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark42">&zwnj;</a
              ><span class="p"
                >A violação de direitos autorais ou de propriedade intelectual de terceiros por parte de Usuário dentro
                das plataformas </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p">é de inteira responsabilidade do transgressor. Os administradores da </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p"
                >devem ser imediatamente alertados pelo titular do direito violado para que proceda à imediata retirada
                do conteúdo, dentro dos termos e normas aplicáveis ao DRM.</span
              >
            </p>
          </li>
          <li data-list-text="9.4.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark43">&zwnj;</a><span class="p">O conteúdo da plataforma </span><span>church web </span
              ><span class="h1"> </span
              ><span class="p"
                >é fornecido ao Usuário apenas da forma que se encontra e não pode ser usado, copiado, reproduzido,
                distribuído, transmitido, difundido, exibido, vendido, licenciado ou de outra forma explorado para
                quaisquer outros fins, sem o consentimento prévio por escrito da SiprySoft.</span
              >
            </p>
          </li>
          <li data-list-text="9.5.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark44">&zwnj;</a>Os Usuários concordam manifestamente em não participar do uso, da cópia ou
              da distribuição de qualquer conteúdo que não seja expressamente permitido, incluindo qualquer uso, cópia
              ou distribuição de conteúdo obtidos através do site ou aplicativo para qualquer fim comercial estranho ao
              objeto destes <b>Termos de Uso</b>. Esses se obrigam a não fraudar, desativar ou de outra forma interferir
              nos recursos de segurança da plataforma <b>church web </b>, sob pena de responsabilização civil e penal.
            </p>
          </li>
          <li data-list-text="9.6.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark45">&zwnj;</a
              ><span class="p"
                >Não é permitida a utilização de nenhum dispositivo, software, ou outro recurso que venha a interferir
                nas atividades e operações da plataforma </span
              ><span>church web </span
              ><span class="p"
                >, bem como nos anúncios, descrições, identificadores e senhas de Usuários ou seus bancos de dados.
                Qualquer intromissão, tentativa de, ou atividade que viole ou contrarie as leis de direito de
                propriedade intelectual e/ou</span
              >
            </p>
            <p style="padding-top: 4pt; padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              as proibições estipuladas nestes Termos de Uso, tornarão o responsável passível das ações legais
              pertinentes, bem como das sanções aqui previstas, sendo ainda responsável pelas indenizações por eventuais
              danos causados.
            </p>
          </li>
          <li data-list-text="9.7.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark46">&zwnj;</a><span class="p">A plataforma </span><span>church web </span
              ><span class="h1"> </span
              ><span class="p"
                >pode possibilitar aos Usuários o acesso a outras ofertas de serviços e produtos, através de e-mails,
                SMS, sites da internet e através de links, o que não significa que esses sejam de propriedade ou mesmo
                operados pela SiprySoft, que, consequentemente, não possui controle sobre os mesmos. A SiprySoft não
                será responsável pelos conteúdos, práticas, serviços e produtos ofertados por terceiros. A presença com
                a oferta de promoções, serviços e produtos de outros sites não implica relação de sociedade, de
                supervisão, de cumplicidade ou solidariedade da plataforma </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p">para com esses outros serviços, produtos, sites e seus conteúdos.</span>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="10.">
        <h1 style="padding-left: 24pt; text-indent: -19pt; text-align: left">
          <a name="bookmark47">&zwnj;</a>Da cessão<span class="p">.</span>
        </h1>

        <ol id="l14">
          <li data-list-text="10.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark48">&zwnj;</a>Os presentes Termos de Uso e quaisquer direitos e licenças aqui concedidas
              são personalíssimos, não podendo ser transferidos nem cedidos pelo Usuário para terceiro, mas podem ser
              atribuídos pela SiprySoft, sem restrições ou limitações.
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="11.">
        <h1 style="padding-left: 24pt; text-indent: -19pt; text-align: left">
          <a name="bookmark49">&zwnj;</a>Da limitação de responsabilidade.
        </h1>

        <ol id="l15">
          <li data-list-text="11.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark50">&zwnj;</a><span class="p">Nestes </span><span class="h1">Termos de Uso</span
              ><span class="p"
                >, a SiprySoft se exime da obrigação de controlar todas as ações executadas pelos Usuários no uso da
                plataforma </span
              ><span>church web </span
              ><span class="p"
                >, de modo que a SiprySoft não poderá ser responsabilizada pelos atos perpetrados por esses, incluindo
                os atos ilícitos ou atos imorais, cabendo ao infrator responder de forma pessoal e exclusiva por
                eventuais reclamações de terceiros e demandas judiciais, ficando a SiprySoft livre de qualquer ônus ou
                responsabilidade.</span
              >
            </p>
          </li>
          <li data-list-text="11.2.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark51">&zwnj;</a
              ><span class="p"
                >A SiprySoft não se responsabiliza por qualquer dano, direto ou indireto, causado por fato de terceiros,
                tais como ataques de hackers, falhas no sistema, no servidor ou na conexão à internet, ação de programas
                maliciosos como vírus, trojan, mallwares e outros que possam danificar o equipamento ou a conexão dos
                Usuários em decorrência do acesso, utilização ou navegação nas plataformas </span
              ><span>church web </span
              ><span class="p">, exceto nos casos em que a SiprySoft incorrer em dolo ou culpa.</span>
            </p>
          </li>
        </ol>
      </li>
      <li data-list-text="12.">
        <h1 style="padding-left: 24pt; text-indent: -19pt; text-align: left">
          <a name="bookmark52">&zwnj;</a>Das disposições gerais.
        </h1>

        <ol id="l16">
          <li data-list-text="12.1.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark53">&zwnj;</a
              ><span class="p"
                >A qualquer momento, a SiprySoft pode requisitar a revalidação das informações cadastrais dos Usuários
                registrados na plataforma </span
              ><span>church web </span
              ><span class="p"
                >, sob o motivo de prevenção de riscos de fraude, falsificação de dados, burlas nos sistemas ou nas
                operações, assim como falsidade ideológica.</span
              >
            </p>
          </li>
          <li data-list-text="12.2.">
            <p style="padding-top: 4pt; padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark54">&zwnj;</a>Sendo constatada qualquer tentativa de fraude, os dados do Usuários serão
              imediatamente colocados à disposição das autoridades competentes para a apuração e inquéritos, assim como
              possíveis sanções judiciais.
            </p>
          </li>
          <li data-list-text="12.3.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark55">&zwnj;</a><span class="p">Havendo suspeita de que o </span
              ><span class="h1">Usuário </span><span class="p">está utilizando a plataforma </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p">de forma ilegal, abusiva ou para outros fins não previstos nestes </span
              ><span class="h1">Termos de Uso</span
              ><span class="p">, a SiprySoft poderá, sem aviso prévio, desativar a conta do usuário.</span>
            </p>
          </li>
          <li data-list-text="12.4.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark56">&zwnj;</a
              ><span class="p"
                >A SiprySoft não se responsabiliza por qualquer dano ou prejuízo causado pelo envio de informações ou de
                conteúdo publicitário que não tenham sido disparados pela própria plataforma </span
              ><span>church web </span
              ><span class="p"
                >, assim como, também não se responsabiliza pelo conteúdo das opiniões postadas na página dos
                Parceiros.</span
              >
            </p>
          </li>
          <li data-list-text="12.5.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark57">&zwnj;</a>Estes <b>Termos de Uso </b>estão sujeitos a mudanças e aprimoramentos.
              Assim, a SiprySoft se reserva o direito de modificá-los a qualquer tempo, seja para adequá-los a mudanças
              na plataforma, seja para adequação à disposição de lei ou de normativa dos órgãos competentes, devendo os
              usuários verificarem estes termos de tempos em tempos.
            </p>
          </li>
          <li data-list-text="12.6.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark58">&zwnj;</a>A eventual tolerância a qualquer violação dos <b>Termos de Uso </b>neste
              domínio será considerada mera liberalidade e não será interpretada, em hipótese alguma, como novação,
              precedente invocável, renúncia de direitos, alteração tácita de termos contratuais, direito adquirido ou
              alteração contratual.
            </p>
          </li>
          <li data-list-text="12.7.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark59">&zwnj;</a>Caso alguma disposição destes <b>Termos de Uso </b>for julgada inaplicável,
              inválida ou sem efeitos, o restante das disposições continua a viger, sem a necessidade de medida judicial
              ou ato da SiprySoft que declare expressamente esta assertiva.
            </p>
          </li>
          <li data-list-text="12.8.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 108%; text-align: justify">
              <a name="bookmark60">&zwnj;</a
              ><span class="p"
                >A comunicação entre a SiprySoft e o Usuário deve ser realizada através dos canais de atendimento
                indicados e disponibilizados na plataforma </span
              ><span>church web </span><span class="p">.</span>
            </p>
          </li>
          <li data-list-text="12.9.">
            <p style="padding-left: 5pt; text-indent: 0pt; line-height: 109%; text-align: justify">
              <a name="bookmark61">&zwnj;</a
              ><span class="p"
                >Na hipótese de divergência entre a SiprySoft e o Usuário, que necessite de resolução pela via judicial,
                as partes concordam, desde já, a eleição do foro do Maceió, no Estado de Alagoas, para resolver as suas
                controvérsias relativas ao uso da plataforma </span
              ><span>church web </span><span class="h1"> </span
              ><span class="p"
                >presentes Termos de Uso, renunciando a quaisquer outros foros, ainda que mais especiais.</span
              >
            </p>
          </li>
        </ol>
      </li>
    </ol>

    <br />
    <h1 style="padding-top: 4pt; text-indent: 0pt; text-align: center">
      <a name="bookmark0">&zwnj;</a>TERMOS DE USO DAS MIDIAS
    </h1>
    <ol id="l1">
      <li data-list-text="1.">
        <h1 style="padding-left: 17pt; text-indent: -12pt; text-align: justify">
          <a name="bookmark2">&zwnj;</a>Informações gerais.
        </h1>
      </li>
    </ol>

    <ol id="l2">
      <li data-list-text="1.1.">
        <p style="padding-left: 5pt; text-indent: 3pt; line-height: 108%; text-align: justify">
          <span class="p">
            AUTORIZO o uso de minha imagem em todo e qualquer material entre imagens de vídeo, fotos e documentos, para
            ser utilizada nas redes sociais, mídias impressas (revistas e jornais), divulgações de eventos e também nas
            peças de comunicação que será veiculada nos canais da COMUNIDADE EVANGÉLICA DO CAMINHO. A presente
            autorização é concedida a título gratuito, abrangendo o uso das imagens coletadas durante reuniões, cultos e
            eventos, em todo território nacional, das seguintes formas: (I)Sites e Blogs; (II) mídia eletrônica
            (vídeo-tapes, televisão, cinema, entre outros)e (III)mídias impressas. Fica ainda autorizada, de livre e
            espontânea vontade, para os mesmos fins, a cessão de direitos da veiculação das imagens não recebendo para
            tanto qualquer tipo de remuneração, as imagens de meus filhos menores de idade (se houver) para os mesmo
            fins.
          </span>
          <br /><br />
          <span>
            Por esta ser a expressão da minha vontade declaro que autorizo o uso acima descrito, sem que nada haja a ser
            reclamado a título de direitos conexos à minha imagem ou a qualquer outro, e aceito o presente termo de
            autorização com meu login da conta google e respectivos dados pessoais.
          </span>

          <span> (Este é um formulário do Depto Jurídico CEC) </span>
        </p>
      </li>
    </ol>
  </body>
</div>
<div class="buttons">
  <button (click)="send(true)" mat-raised-button class="btn-primary">Aceitar</button>
  <br />
  <button (click)="send(false)" mat-raised-button class="btn-segundary">Rejeitar</button>
</div>
